export default "__VITE_ASSET__BTtycoUr__"